var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRestaurantcomponent = function SvgRestaurantcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.5h1.333V1.833h1.334V6.5A2.666 2.666 0 0 1 6 9.167v6H4.667v-6A2.666 2.666 0 0 1 2 6.5V1.833h1.333V6.5h1.334V1.833H6V6.5Zm4.667 3.334V4.5c0-1.173 1.493-2.667 3.333-2.667v13.334h-1.333V9.834h-2Z",
    fill: "current"
  })));
};
export default SvgRestaurantcomponent;